query userPromo {
  userPromo {
    activeStep {
      id
      target
      balance
      condition
      conditionDetails
      gameIdsList
      finishBefore
      propsContent {
        props
        type
      }
      filters {
        type
        value
      }
      userProgram {
        id
        canBeFinishByUser
        activationConditionsFailed
        isActivated
        propsContent {
          activeSettings {
            activeStart
            activeEnd
          }
          props
          type
        }
        program {
          id
          title
          description
          details
          dateStart
          dateEnd
          section
          compressedImage {
            webp {
              lg
            }
          }
          activationConditions
          processConditions
        }
      }
      showModalBonus
    }
    programsAvailable {
      id
      error
      fromRegistration
      activateBefore
      canBeActivate
      activationConditionsFailed
      fromPromocodeTitle
      created
      isActivated
      propsContent {
        activeSettings {
          activeStart
          activeEnd
        }
        props
        type
      }
      program {
        id
        title
        description
        details
        section
        dateStart
        dateEnd
        parent
        compressedImage {
          webp {
            lg
          }
        }
        activationConditions
        processConditions
      }
    }
  }
}
